<template>
  <div>
    <a
      :href="href"
      class="flex items-center flex-col h-32 w-32 border border-gray-300 hover:border-h-orange transition-color duration-200 ease-in-out rounded-lg mx-4 justify-center"
    >
      <img :src="icon" class="mb-2" />
      <span class="text-headline font-medium text-sm">
        <slot></slot>
      </span>
    </a>
  </div>
</template>

<script>
export default {
  name: "RoHAnchorButton",
  props: {
    icon: {
      type: String,
      default: "",
    },
    href: {
      type: String,
      default: "",
    },
  },
  methods: {},
};
</script>

<style scoped></style>
